import { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs } from 'components/app';
import { Container, IconButton } from 'components/elements';
import { getSystemTheme, systemTheme } from 'store/system';
import { PageHeaderBreadcrumbsWrapper, StyledPageHeader } from './PageHeader.styled';
import { PageHeaderProps } from './types';
import { HeaderContainerStyle } from 'styles/InlineStyles';

export const PageHeader: FunctionComponent<PageHeaderProps> = props => {
  const { breadcrumbs = [], children } = props;

  // Retrieve application store dispatcher
  const dispatch = useDispatch();

  // Retrieve application configuration
  const themeVariant = useSelector(getSystemTheme);

  /**
   * Handle clicking on the theme switch button
   */
  const handleThemeSwitch = useCallback(() => {
    switch (themeVariant) {
      case 'dark':
        dispatch(systemTheme('light'));
        break;
      case 'light':
      default:
        dispatch(systemTheme('dark'));
        break;
    }
  }, [dispatch, themeVariant]);

  return (
    <Container style={HeaderContainerStyle}>
      <PageHeaderBreadcrumbsWrapper>
        <Breadcrumbs entries={breadcrumbs} />
        <IconButton icon="theme switch" variant="transparent" onClick={handleThemeSwitch} />
      </PageHeaderBreadcrumbsWrapper>
      <StyledPageHeader>{children}</StyledPageHeader>
    </Container>
  );
};
